exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-btn[data-v-5057b094]{border:none;width:100%;background-color:#f5f5f5;padding:.5em 0}.add-btn[data-v-5057b094]:hover{background-color:#e8e8e8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5057b094","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Account/AccountAddresses.vue
// module id = S72X
// module chunks = 0